import React, { useState, useEffect, useMemo } from "react";
import Table from "../../Components/Common/Table/Table";
import { CommonSubHeader } from "../../Components/helpers/Helpers";
import TableActions from "../../Components/Common/Table/TableActions";
import { Groups2 } from "@mui/icons-material";
import api from "../../api/axios";
import LoadingPage from "../../Components/Common/Loading/LoadingPage";

function Grupos() {
  const [groups, setGroups] = useState([]);
  const [objPerPage, setObjPerPage] = useState(10);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pagePressed, setPagePressed] = useState(1);
  const [loading, setLoading] = useState(false);
  const [changeDone, setChangeDone] = useState(false);

  const [sortColumn, setSortColumn] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);

  const handleSort = (column, direction) => {
    setSortColumn(column);
    setSortDirection(direction);
    setPagePressed(1);
  };

  const getDataGroups = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/groups`,
        {
          page: pagePressed,
          objPerPage,
          sortColumn,
          sortDirection,
        },
      );

      const {
        data: groupsData = [],
        total = 0,
        last_page = 0,
      } = data.groups || {};
      setGroups(groupsData);
      setTotalPagesNumber(total);
      setPageCount(last_page);
    } catch (error) {
      console.error("Error en la respuesta del servidor:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getDataGroups();
  }, [pagePressed, objPerPage, changeDone, sortColumn, sortDirection]);

  useEffect(() => {
    if (pagePressed > pageCount && pageCount > 0) {
      setPagePressed(1);
    }
  }, [pagePressed, pageCount]);

  const formatDate = (value) => {
    if (!value) return "Sin registro";
    const parsedDate = new Date(value);
    if (Number.isNaN(parsedDate.getTime())) return value;
    return parsedDate.toLocaleString("es-ES");
  };

  const resolveTraceUser = (row, type) => {
    const candidates =
      type === "create"
        ? [
            row?.created_by_name,
            row?.created_by,
            row?.created_by_user?.full_name,
            row?.created_by_user?.name,
            row?.creator?.full_name,
            row?.creator?.name,
            row?.user_created,
          ]
        : [
            row?.updated_by_name,
            row?.updated_by,
            row?.updated_by_user?.full_name,
            row?.updated_by_user?.name,
            row?.updater?.full_name,
            row?.updater?.name,
            row?.user_updated,
          ];

    return candidates.find((value) => value) || "Sin registro";
  };

  const renderCellWithDefault = (value, fallback = "Sin registro") => (
    <div className="spanClassForTables centerContent">{value || fallback}</div>
  );

  const columns = useMemo(
    () => [
      {
        Header: "LISTA DE GRUPOS",
        columns: [
          {
            Header: "Grupo",
            accessor: "grupo",
            sortField: "grupo",
            minWidth: 250,
            Cell: ({ value }) => renderCellWithDefault(value, "Sin nombre"),
          },
          // {
          //   Header: "Creado por",
          //   accessor: "created_by_name",
          //   minWidth: 180,
          //   Cell: ({ row }) => renderCellWithDefault(resolveTraceUser(row.original, "create")),
          // },
          // {
          //   Header: "Fecha creación",
          //   accessor: "created_at",
          //   sortField: "created_at",
          //   minWidth: 190,
          //   Cell: ({ value }) => renderCellWithDefault(formatDate(value)),
          // },
          // {
          //   Header: "Actualizado por",
          //   accessor: "updated_by_name",
          //   minWidth: 180,
          //   Cell: ({ row }) => renderCellWithDefault(resolveTraceUser(row.original, "update")),
          // },
          // {
          //   Header: "Última actualización",
          //   accessor: "updated_at",
          //   sortField: "updated_at",
          //   minWidth: 190,
          //   Cell: ({ value }) => renderCellWithDefault(formatDate(value)),
          // },
          {
            Header: "Acciones",
            accessor: "id",
            minWidth: 120,
            Cell: ({ value }) => (
              <TableActions
                rute="grupos"
                value={value}
                showEdit
                showDelete
                module="group"
                apiRute="groups"
                setChangeDone={setChangeDone}
                changeDone={changeDone}
              />
            ),
          },
        ],
      },
    ],
    [changeDone],
  );

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Configuración" subTitle="Grupos" />

      <div className="mainContainer">
        <div className="subMainContainer">
          {loading && <LoadingPage isLoading={loading} heightProp="60vh" />}

          {!loading && (
            <Table
              columns={columns}
              data={groups}
              view="grupo"
              viewTitle="grupos"
              totalPagesNumber={totalPagesNumber}
              tableWidth="unset"
              minTableWidth="75%"
              icon={Groups2}
              viewPermission="group"
              apiRoute="groups"
              onPageChange={(event) => setPagePressed(event.selected + 1)}
              pageCount={pageCount}
              forcePage={pagePressed - 1}
              onSort={handleSort}
              sortColumn={sortColumn}
              sortDirection={sortDirection}
              setChangeDone={setChangeDone}
              changeDone={changeDone}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default Grupos;
